const state = {
    baseData: [],
    token:'11'
}
const mutations = {
    loginOut(state) {
        state.token = ""
        state.userId = ""
        localStorage.removeItem('token')
        localStorage.removeItem('userId')
    }
}
const actions = {}
export default {
    namespaced:true,
    state,
    mutations,
    actions
}